import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { fetchUserData } from "./FetchData";
import { updateUserInfo } from "../store/actions/userAction";
import { listNotPrivate } from "../utils/configData";
import { updateLimit } from "../store/actions/limitAction";


const PrivateRoute = ({ children }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const userAuth = useSelector((state) => state.user.isAuth);
  const userType = useSelector((state) => state.user.type);
  const [isAuthChecked, setIsAuthChecked] = useState(false);
  const [NotCompleted, setIsNotCompleted] = useState(false);

  useEffect(() => {
    // check user data
    if (!userAuth) {
      fetchUserData().then((data) => {
        updateUserInfo(dispatch, data);
        setIsAuthChecked(true);
        if (data.NotCompleted) {
          setIsNotCompleted(true);
        }
        if (data.id) {
          updateLimit(dispatch, data.id);
        }
      });
    } else {
      // if user is authenticated, set isAuthChecked to true
      setIsAuthChecked(true);
    }
  }, [userAuth, dispatch]);

  

  if (!isAuthChecked) {
    // if user is not authenticated, check user data
    console.log("Loading...");
    return null;
  }



  // compilation of a list of pages, navigation on which is allowed without authorization
  const isNotAuthPage = listNotPrivate.every(
    (el) => !location.pathname.includes(el)
  );
  const isAuthPage = !isNotAuthPage;

  if (NotCompleted  && isNotAuthPage && !userAuth) {
 
    return <Navigate to={`/sign-up`} state={{ from: location }}/>;
  }

  if (!userAuth && isNotAuthPage) {
    // if user is not authenticated and not on sign-in or sign-up page, redirect to sign-in
    return <Navigate to={`/sign-in`} state={{ from: location }} />;
  }

  if (userAuth && isAuthPage) {
    // if user is authenticated and on sign-in or sign-up page, redirect to home
    if (userType === 0) {
      console.log("userType", userType);
      return <Navigate to={`/`} />;
    } else {
      return <Navigate to={`/transactions-list`} />;
    }
   
  }

  
  return children;
};

export default PrivateRoute;
